var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-field',{attrs:{"label":"Notas Importantes","label-position":"on-border"}},[_c('b-input',{attrs:{"maxlength":"500","type":"textarea","required":""},model:{value:(_vm.reservation.NotasImportantes),callback:function ($$v) {_vm.$set(_vm.reservation, "NotasImportantes", $$v)},expression:"reservation.NotasImportantes"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }